<template>
    <div class="tool-panel">
        <span>文件上传</span>
        <input type="file" class="form-control form-control-sm" aria-label="上传文件">
        <button class="btn btn-outline-secondary btn-sm upload-btn" type="button">上传</button>
    </div>
</template>

<script>
export default {
    name: "ChatRoomTool",
}
</script>

<style scoped>
.tool-panel {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr) auto;
    align-items: center;
    gap: 10px;
    padding: 12px 18px;
    background: var(--app-surface);
    border-top: 1px solid var(--app-border);
}

.tool-panel span {
    color: var(--app-muted);
    font-size: 0.82rem;
    font-weight: 800;
}

.tool-panel input {
    background: var(--app-surface-strong);
    color: var(--app-text);
    border-color: var(--app-border);
}

.upload-btn {
    min-width: 72px;
}

@media (max-width: 576px) {
    .tool-panel {
        grid-template-columns: 1fr;
        align-items: stretch;
    }

    .upload-btn {
        width: 100%;
    }
}
</style>
